export default __webpack_public_path__ + "static/CTL_logo-dee4cca54275a9cd51f40a91caf2ead3.png";